import { axiosRequest } from '../../axiosRequest';

export const RECIPIENTS_PAGE_LIMIT = 20;

// Phone numbers are stored in E.164 (+14155552671): when the search looks
// like a phone number, drop the formatting so "(415) 555" still matches.
const normalizeSearch = (search) => {
	const value = (search || '').trim();
	if (/^[\d\s()+.-]+$/.test(value)) return value.replace(/[^\d+]/g, '');
	return value;
};

const adapterAppRequest = ({ status, search, page, limit } = {}) => {
	const query = {
		page: page || 1,
		limit: limit || RECIPIENTS_PAGE_LIMIT,
	};
	if (status) query.status = status;
	const normalizedSearch = normalizeSearch(search);
	if (normalizedSearch) query.search = normalizedSearch;
	return query;
};

const adapterAppResponse = ({ data, success }) => {
	if (success === false) return { error: true, data };

	const recipients = Array.isArray(data?.recipients)
		? data.recipients.map((i) => ({
				id: i?.id,
				member_id: i?.member_id,
				phone_number: i?.phone_number,
				status: i?.status,
				error_code: i?.error_code ?? null,
				error_message: i?.error_message || null,
				message_sid: i?.message_sid || null,
				attempts: i?.attempts ?? 0,
				// Raw ISO dates, displayed with the time.
				sent_at: i?.sent_at || null,
				status_at: i?.status_at || null,
				// null when the member was deleted
				member: i?.member
					? {
							first_name: i.member.first_name,
							last_name: i.member.last_name,
					  }
					: null,
		  }))
		: [];

	const pagination = {
		page: data?.pagination?.page ?? 1,
		limit: data?.pagination?.limit ?? RECIPIENTS_PAGE_LIMIT,
		total: data?.pagination?.total ?? 0,
		total_pages: data?.pagination?.total_pages ?? 0,
	};

	return { recipients, pagination };
};

export const getNotificationRecipients = async (notificationId, filters) => {
	var options = {
		method: 'get',
		url: `dashboard/notifications/${notificationId}/recipients`,
		query: adapterAppRequest(filters),
	};

	const response = await axiosRequest(options);

	const recipients = adapterAppResponse(response);

	return recipients;
};
